import React from 'react'
import './RoomDetails.css'

const RoomDetails = ({ toggleModal, Esrooms, id }) => {	
	
	const room = Esrooms.filter((room) => room.id === id)

	return (
			<div className='profile-modal'>
				<article className="article">
			        <button className='modal-close' onClick={()=>toggleModal()}>
			        	&times;
			        </button>
			        <main className="pa4 w-100 tc" >
			          <h1>{room[0].name}</h1>
					  <h4>{room[0].company}</h4>
					  <p>{room[0].description}</p>
					  		                				        
			        </main>
			        
			    </article>			
			</div>	
		)
}

export default RoomDetails;


// WEBPACK FOOTER //
// ./src/RoomDetails/RoomDetails.js